import React, { useContext, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";

import { CurrentAging } from "./CurrentAging";
import { AsOfAging } from "./AsOfAging";
import { DateRange } from "./DateRange";
import TabBasedFeature from "../../../components/layout/TabBasedFeature";
import { UserContext } from "shared/context/UserContext";
import { useFetchAgingPeriods } from "./hooks/useFetchAgingPeriods";
import { ControlSpinner } from "shared/components/spinners/ControlSpinner";

export default function Aging(props) {
  const [agingPeriodsParameters, setAgingPeriodsParameters] = useState(null);
  const userContext = useContext(UserContext);

  useEffect(() => {
    if (userContext.locations && userContext.locations.length > 0) {
      let mmidValues = [];

      userContext.locations.forEach((e) => {
        mmidValues.push(e.value);
      });

      setAgingPeriodsParameters({
        user: userContext.email,
        mmids: mmidValues.join(","),
      });
    }
  }, [userContext.locations]);

  let { data: agingPeriodData, isError, error } = useFetchAgingPeriods(agingPeriodsParameters);

  let tabs = [
    { key: "currentAging", title: "Current Aging", Component: CurrentAging },
    { key: "dateRange", title: "Date Range", Component: DateRange },
    { key: "asOfAging", title: '"As Of" Aging', Component: AsOfAging },
  ];

  if (isError) {
    // Display the error message - either the custom user message or the default error
    const errorMessage = (error && error.userMessage) || 
                        (error && error.description) || 
                        (error && error.message) || 
                        "An error occurred while loading aging periods. Please try again later.";
    
    // Use the error title from the error object, or default to "Error"
    const errorTitle = (error && error.errorTitle) || "Error";
    
    return (
      <div className="p-3">
        <Alert variant="danger">
          <Alert.Heading>{errorTitle}</Alert.Heading>
          <p>{errorMessage}</p>
        </Alert>
      </div>
    );
  }

  if (!agingPeriodData) {
    return <ControlSpinner />;
  } else {
    let constructedProps = {
      ...props.passedProps,
      agingPeriods: agingPeriodData,
    };

    return (
      <TabBasedFeature
        tabs={tabs}
        defaultActiveKey="currentAging"
        passedProps={constructedProps}
      />
    );
  }
}
